import axios from "axios";

export const getTenantStats = () => {
    return axios.get("/api/v2/tenant/stats");
};

export const getTenantPaymentStats = () => {
    return axios.get("/api/v2/tenant/stats/payment");
};

export const getPlanetHdPools = () => {
    return axios.get("/api/v1/users/admin/planet-hd/pools");
};

export const createPlanetHdPool = data => {
    return axios.post("/api/v1/users/admin/planet-hd/pools", data);
};

export const reconcilePlanetHdPool = poolId => {
    return axios.post(`/api/v1/users/admin/planet-hd/pools/${poolId}/reconcile`);
};
